import { createElement } from 'react'
import {
    office365 as office365Fn,
    office365Mobile as office365MobileFn,
} from 'calendar-link'

import { Cal365Icon } from '@pleio/icons/cal-365'

import { type CalendarEvent } from '../CalendarEvent'
import { type WebCalendarService } from '../CalendarLink'
import descriptionAsHtml, { addBreak } from '../descriptionAsHtml'
import normalizeLocation from '../normalizeLocation'

export default function office365(
    label: string,
    isMobile: boolean,
): (event: CalendarEvent) => WebCalendarService {
    return function office365Link(event: CalendarEvent): WebCalendarService {
        return {
            label,
            url: (isMobile ? office365MobileFn : office365Fn)({
                start: event.start,
                end: event.end,
                title: event.title,
                description: descriptionAsHtml(event, addBreak()),
                location: normalizeLocation(event),
                url: event.eventPageUrl,
            }),
            newWindow: true,
            iconBefore: createElement(Cal365Icon),
        }
    }
}
